import React from 'react'
import { Helmet } from "react-helmet";
import Hero from '../../components/Courses/Hero'
import Course from '../../components/Courses/Course'
import Certifications from '../../components/Courses/Certifications'
import CourseOptions from '../../components/Courses/CourseOptions'

const Courses = () => {
  return (
    <>
<Helmet>
  {/* Google Analytics Tag */}
  <script async src="https://www.googletagmanager.com/gtag/js?id=AW-16818142902"></script>
  <script>
    {`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-16818142902');
    `}
  </script>

  {/* Basic Meta */}
  <title>Courses | Aptech Lekki Centre - IT Training, Certifications, and Career Programs</title>
  <meta charSet="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  
  <meta
    name="description"
    content="Explore Aptech Lekki's wide range of IT courses including Software Development, Mobile App Development, Data Analytics, Digital Marketing, Project Management, and more. Get globally recognized certifications and start your tech career journey today!"
  />
  
  <meta
    name="keywords"
    content="Aptech Lekki courses, IT training Lekki, Learn programming Nigeria, Software engineering courses Lekki, Digital marketing training Lagos, Mobile app development Nigeria, Project management certification Lekki, Tech career programs Lagos, Coding bootcamp Lekki"
  />
  
  <meta name="author" content="Aptech Lekki Centre" />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://aptechlekki.com/courses" />

  {/* Open Graph Meta for Social Sharing */}
  <meta property="og:title" content="Courses | Aptech Lekki Centre" />
  <meta property="og:description" content="Discover IT training and certification courses at Aptech Lekki. Learn programming, mobile development, project management, and more." />
  <meta property="og:url" content="https://aptechlekki.com/courses" />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="https://aptechlekki.com/assets/og_image.jpg" />

  {/* Twitter Card */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Courses | Aptech Lekki Centre" />
  <meta name="twitter:description" content="Enroll in top-rated IT programs at Aptech Lekki Centre. Get career-ready with professional tech certifications." />
  <meta name="twitter:image" content="https://aptechlekki.com/assets/og_image.jpg" />
</Helmet>

      <Hero />
      <CourseOptions />
      <Course />
      <Certifications />
    </>
  )
}

export default Courses